import React from "react";
import { Link } from "react-router-dom";
import HeadMeta from "@/components/sections/HeadMeta";
import Header from "@/components/sections/Header";
import Footer from "@/components/sections/Footer";
import Subvencio from "@/components/sections/Subvencio";
import { usePageInitialization } from "@/hooks/usePageInitialization";

const PoliticaCookiesPage = () => {
  usePageInitialization("Política de cookies - Elemental Value", { handleSplash: false, initSwiper: false });
  
  return (
    <>
      <HeadMeta
        title="Política de cookies | Elemental Value"
        description="Tipos de cookies utilizadas en elementalvalue.co, finalidades, duración y cómo configurarlas o desactivarlas en tu navegador."
        canonicalPath="/politica-cookies"
      />
      <Header />
      <main className="legal-page">
        <div className="legal-content">
          <h1>Política de cookies</h1>
...
          <section>
            <h2>6. Actualización de la Política de cookies</h2>
            <p>
              Esta política de cookies puede actualizarse en cualquier momento para adaptarse a novedades legislativas o cambios en nuestras prácticas. Le recomendamos revisar periódicamente esta página para estar informado sobre cómo utilizamos las cookies.
            </p>
          </section>

          <section>
            <h2>7. Más Información</h2>
            <p>
              Para más información sobre el tratamiento de sus datos personales, consulte nuestra <Link to="/politica-privacidad">Política de privacidad</Link>.
            </p>
            <p>
              Si tiene alguna pregunta sobre nuestra política de cookies, puede contactarnos en: <strong>info@elementalvalue.co</strong>
            </p>
          </section>

        </div>
      </main>
      <Footer />
      <Subvencio />
    </>
  );
};

export default PoliticaCookiesPage;
